import React from 'react'
import { NavBar } from '../NavBar/NavBar'
import { HomeRouter } from './HomeRouter'
import './HomeContainer.scss';

export const HomeContainer = ({path,toggleHowWorks,toggleAddCareer,toggleDeleteCareer,toggleAddOpinion,toggleAddTutor,myTutor}) => {
  return (
    <div className="home-container">
        <NavBar className="navbar"/>
        <HomeRouter className="home-router" path={path} toggleAddOpinion={toggleAddOpinion} toggleDeleteCareer={toggleDeleteCareer} toggleAddCareer={toggleAddCareer} toggleHowWorks={toggleHowWorks} toggleAddTutor={toggleAddTutor} myTutor={myTutor}/>
        <a className='banner' target='_blank' href='https://www.ioteris.com.ar'><img src="https://i.imgur.com/Ii64qHJ.png"/></a>
    </div>
  )
}
